import type { FetcherAxiosInstance } from '../fetcher';

export const createCartApi = (Fetcher: FetcherAxiosInstance) => ({
  mergeCart({
    anonymousCartId, authCartId = null, isDelete = false, territoryId,
  }) {
    if (typeof anonymousCartId === 'undefined') {
      return Promise.reject('ananonymousCartId is required');
    }

    if (typeof territoryId === 'undefined') {
      return Promise.reject('territoryId is required');
    }

    return Fetcher.post(
      '/cart/_merge',
      {
        cartIds: {
          anonymous: anonymousCartId,
          auth: authCartId,
        },
        isDelete,
        territoryId,
      },
    );
  },
});

